import logo from './assets/images/Healthbouk_Logo_png.png';
import qr from './assets/images/healthbouk_v2.png'
import left from './assets/images/left_img.png';
import right from './assets/images/right_img.png';
import './App.css';
import { useState, useRef, useEffect } from 'react';
import SignaturePad from 'signature_pad';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { removeBackground } from 'modern-rembg';

function App() {
  const [formData, setFormData] = useState({
    patientName: 'KEVIN SMITH',
    birthDate: 'January 1, 2025',
    vaccinationType: 'HepB',
    vaccinationDate: 'January 20, 2025',
    serviceProvider: 'Dr. John Adams',
    signature: null
  });
  
  // API state
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [vaccinationId, setVaccinationId] = useState('');
  const [token, setToken] = useState('');
  
  // Certificate state
  const [certificateId, setCertificateId] = useState(null);
  const [verifiedDate, setVerifiedDate] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [isSignatureSubmitted, setIsSignatureSubmitted] = useState(false);
  const [dateVerified, setDateVerified] = useState(false);

  //VIsibility of form
  const [showForms, setShowForms] = useState(true);

  //Visibility of certificate
  const [showCertificate, setShowCertificate] = useState(true);
  
  // Signature pad code
  const [imageURL, setImageURL] = useState(null);
  const canvasRef = useRef(null);
  const signaturePadRef = useRef(null);

  // API base URL - adjust this to match your API server
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // API Functions
  const fetchVaccinationData = async (vaccinationId) => {
    setLoading(true);
    setError(null);
    
    try {
      //console.log('Fetching data for Vaccination ID:', vaccinationId);
      //console.log('Using token:', token.substring(0, 20) + '...');
      
      // Fetch vaccination data with child information
      const response = await fetch(`${API_BASE_URL}/vaccination/${vaccinationId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      //console.log('Response status:', response.status);
      //console.log('Response headers:', response.headers);

      if (!response.ok) {
        const errorText = await response.text();
        //console.error('Error response:', errorText);
        throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      //console.log('Received data:', data);
      
      if (data.vaccination) {
        const vaccination = data.vaccination;
        const child = vaccination.child;
        
        // Check if the vaccination is completed
        if (vaccination.status === 'Completed') {
          setFormData({
            patientName: child.name.toUpperCase(),
            birthDate: formatDate(child.birthday),
            vaccinationType: vaccination.name,
            vaccinationDate: formatDate(vaccination.date),
            serviceProvider: vaccination.providerName,
            signature: null
          });
        } else {
          // Set child info but show error for non-completed vaccination
          setFormData(prev => ({
            ...prev,
            patientName: child.name.toUpperCase(),
            birthDate: formatDate(child.birthday)
          }));
          setError(`This vaccination is not completed (Status: ${vaccination.status}). Only completed vaccinations can have certificates.`);
        }
      }
      
    } catch (err) {
      //console.error('Fetch error details:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // New function to validate signature token and fetch certificate data
  const validateSignatureToken = async (token) => {
    setLoading(true);
    setError(null);
    
    try {
      //console.log('Validating signature token:', token.substring(0, 20) + '...');
      
      // Validate signature token and fetch certificate data
      const response = await fetch(`${API_BASE_URL}/signature/validate/${token}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      //console.log("Actual response", response);
      

      //console.log('Response status:', response.status);

      const text = await response.text(); 
      let body;
      try {
        body = JSON.parse(text);           
      } catch {
        body = text;                    
      }

      if (!response.ok) {
        const errorMessage =
          (body && body.error) ||
          (body && body.message) ||
          (typeof body === 'string' ? body : 'Something went wrong');

        //console.error('Error response message:', errorMessage);
        setError(errorMessage);
        if (body && body.tokenExpired === true) {
          setShowCertificate(false);
          setShowForms(false);
        }
        if (body && body.alreadySigned === true) {
          setIsSignatureSubmitted(true);
          
          const { certificate, vaccination, child } = body;
        
          // Set certificate information
          setCertificateId(certificate.certificateId);
          
          // Set form data with vaccination and child information
          setFormData({
            patientName: child.name.toUpperCase(),
            birthDate: formatDate(child.birthday),
            vaccinationType: vaccination.vaccineName,
            vaccinationDate: formatDate(vaccination.date),
            serviceProvider: vaccination.providerName,
            signature: certificate.signature
          });

          if (certificate.verifiedDate) {
            setDateVerified(new Date(certificate.verifiedDate).toLocaleDateString('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric'
            }));
          } else {
            setDateVerified(new Date().toLocaleDateString('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric'
            }));
          }
            
          
          // Set vaccination ID for future use
          setVaccinationId(vaccination.id);

          //Set Show form False because its already signed
          setShowForms(false);
        }
        return;
      }

      // const data = await response.json();
      //console.log('Received certificate data:', body);
      
      if (body.valid && body.certificate && body.vaccination && body.child) {
        const { certificate, vaccination, child } = body;
        
        // Set certificate information
        setCertificateId(certificate.certificateId);
        
        // Set form data with vaccination and child information
        setFormData({
          patientName: child.name.toUpperCase(),
          birthDate: formatDate(child.birthday),
          vaccinationType: vaccination.vaccineName,
          vaccinationDate: formatDate(vaccination.date),
          serviceProvider: vaccination.providerName,
          signature: null
        });

        if (certificate.verifiedDate) {
          setDateVerified(new Date(certificate.verifiedDate).toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric'
          }));
        } else {
          setDateVerified(new Date().toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric'
          }));
        }
        
        // Set vaccination ID for future use
        setVaccinationId(vaccination.id);

        setShowForms(true);
        
        //console.log('Certificate data loaded successfully');
      } else {
        throw new Error('Invalid response format from server');
      }
      
    } catch (err) {
      throw new Error('Token validation error:', err);
      //setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Format date to match the certificate format
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const handleFetchData = () => {
    if (!vaccinationId || !token) {
      alert('Please enter Vaccination ID and JWT Token');
      return;
    }
    fetchVaccinationData(vaccinationId);
  };

  useEffect(() => {
    if (canvasRef.current) {
      signaturePadRef.current = new SignaturePad(canvasRef.current, {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        penColor: 'rgb(0, 0, 0)'
      });
    }
    
    // Handle window resize for responsive canvas
    const handleResize = () => {
      if (canvasRef.current && signaturePadRef.current) {
        const canvas = canvasRef.current;
        const { width, height } = getCanvasSize();
        canvas.width = width;
        canvas.height = height;
        signaturePadRef.current.clear();
      }
    };
    
    // Initial size setting
    handleResize();
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!formData.signature && canvasRef.current) {
      signaturePadRef.current = new SignaturePad(canvasRef.current, {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        penColor: 'rgb(0, 0, 0)'
      });
    }
  }, [formData.signature]);


  // Handle URL parameters for automatic token validation
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenParam = urlParams.get('token');
    
    if (tokenParam) {
      //console.log('Token found in URL, validating...');
      setToken(tokenParam);
      validateSignatureToken(tokenParam);
    }
  }, []);

  // Function to get responsive canvas dimensions
  const getCanvasSize = () => {
    const width = window.innerWidth;
    if (width <= 360) {
      return { width: 120, height: 50 };
    } else if (width <= 480) {
      return { width: 140, height: 55 };
    } else if (width <= 768) {
      return { width: 160, height: 65 };
    } else if (width <= 1024) {
      return { width: 200, height: 80 };
    } else if (width <= 1199) {
      return { width: 220, height: 90 };
    } else if (width <= 1399) {
      return { width: 240, height: 100 };
    }
    return { width: 280, height: 120 };
  };

  /* a function that clears the signature pad and uploaded signatures */
  const clear = () => {
    // Clear the signature pad if it exists
    if (signaturePadRef.current) {
      signaturePadRef.current.clear();
    }
    
    // Clear any uploaded signature from form data
    setFormData(prev => ({
      ...prev,
      signature: null
    }));
    
    // Clear the image URL state
    setImageURL(null);
    
    // Reset verified date
    setVerifiedDate(null);
    
    // Reset submitted state
    setIsSignatureSubmitted(false);
    
    // Reset the file input
    const fileInput = document.getElementById('signature-upload');
    if (fileInput) {
      fileInput.value = '';
    }
    
    //console.log('Signature cleared');
  };

  /* a function that saves the signature */
  const save = () => {
    if (signaturePadRef.current && !signaturePadRef.current.isEmpty()) {
      const dataURL = signaturePadRef.current.toDataURL("image/png");
      setImageURL(dataURL);
      setFormData(prev => ({
        ...prev,
        signature: dataURL
      }));
      setVerifiedDate(new Date().toISOString());
      setIsSignatureSubmitted(false);
      //console.log('Signature saved from signature pad');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      //console.log("File upload cancelled");
      e.target.value = "";
      return;
    }
    else {
      const invalidChars = /[(),{};:]/;
      if (invalidChars.test(file.name)) {
        alert('File name should not contain commas, parentheses, curly braces, semicolons, or colons.');
        return;
      }

      // Check if file is PNG
      if (!file.type.includes('png')) {
        alert('Please select a PNG file for signature upload.');
        return;
      }
      
      // Check file size (limit to 2MB)
      if (file.size > 2 * 1024 * 1024) {
        alert('File size should be less than 2MB.');
        return;
      }

      try {
        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const data = imageData.data;

          for (let i = 0; i < data.length; i += 4) {
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];

            
            if (r > 220 && g > 220 && b > 220) {
              data[i + 3] = 0;
            }
          }

          ctx.putImageData(imageData, 0, 0);

          const result = canvas.toDataURL("image/png");

          setFormData(prev => ({
            ...prev,
            signature: result,
          }));
          setVerifiedDate(new Date().toISOString());
          setIsSignatureSubmitted(false);
        };
      } catch (err) {
        alert("Failed to process image. Try another image or reduce size.");
      }
      
      // const reader = new FileReader();
      // reader.onload = (e) => {
      //   setFormData(prev => ({
      //     ...prev,
      //     signature: e.target.result
      //   }));
      //   setVerifiedDate(new Date().toISOString());
      //   setIsSignatureSubmitted(false);
      //   //console.log('Signature uploaded:', file.name);
      // };
      // reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.signature) {
      alert('Please add a signature before submitting the certificate.');
      return;
    }
    
    if (!vaccinationId || !token) {
      alert('Please load vaccination data first.');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      // Generate PDF (get both filename and blob for upload)
      //console.log('Generating PDF...');
      const { filename: pdfFilenameGen, pdfBlob } = await generatePDF();

      // Prepare signature blob (from canvas dataURL in formData.signature)
      const signatureDataUrl = formData.signature; // data:image/png;base64,...
      const signatureBlob = dataURLToBlob(signatureDataUrl);
      const signatureFileName = 'signature.png';

      // Build multipart form-data
      const form = new FormData();
      form.append('vaccinationId', vaccinationId);
      if (certificateId) form.append('certificateId', certificateId);
      form.append('signature', signatureBlob, signatureFileName);
      form.append('signatureFilename', signatureFileName);
      form.append('pdf', pdfBlob, pdfFilenameGen);
      form.append('pdfFilename', pdfFilenameGen);

      // Submit to backend as multipart/form-data
      //console.log('Submitting signature and PDF (multipart)...');
      const submitResponse = await fetch(`${API_BASE_URL}/signature/submit/${token}`, {
        method: 'POST',
        body: form
      });

      const text = await submitResponse.text(); 
      let body;
      try {
        body = JSON.parse(text);           
      } catch {
        body = text;                    
      }

      if (!submitResponse.ok) {
        const errorMessage =
          (body && body.error) ||
          (body && body.message) ||
          (typeof body === 'string' ? body : 'Something went wrong');

        //console.error('Error response message:', errorMessage);
        throw new Error(`${errorMessage}`);
      }

      const submitData = await submitResponse.json();

      alert('Signature submitted successfully!');
      //console.log('Signature submitted:', submitData);
      setIsSignatureSubmitted(true);
      
      // Close the tab/window
      if (window.opener) {
        window.close();
      } else {
        // If not opened as popup, just show success message
        alert('Signature submitted successfully! You can now close this tab.');
      }
      
    } catch (error) {
      //console.error('Error submitting signature:', error);
      alert(`Error submitting signature: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const generateCertificateId = () => {
    return certificateId || 'DRAFT-CERTIFICATE';
  };

  const getCurrentDate = () => {
    if (verifiedDate) {
      return new Date(verifiedDate).toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      });
    }
    return new Date().toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    });
  };

  // PDF Generation Function
  const generatePDF = async () => {
    setIsGeneratingPDF(true);
    
    try {
      const certificateElement = document.querySelector('.certificate-container');
      
      if (!certificateElement) {
        throw new Error('Certificate container not found');
      }

      // Hide buttons and form elements during PDF generation
      const formActions = document.querySelector('.form-actions');
      const apiForm = document.querySelector('.api-form-container');
      const signatureControls = document.querySelector('.signature-controls');
      
      if (formActions) formActions.style.display = 'none';
      if (apiForm) apiForm.style.display = 'none';
      if (signatureControls) signatureControls.style.display = 'none';

      // Generate canvas from certificate
      const canvas = await html2canvas(certificateElement, {
        scale: 1.5, 
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false, // Disable logging for better performance
        imageTimeout: 0,
        removeContainer: true,
        width: certificateElement.scrollWidth,
        height: certificateElement.scrollHeight,
        scrollX: 0,
        scrollY: 0
      });

      // Debug logging
      // console.log('Certificate element dimensions:', {
      //   width: certificateElement.scrollWidth,
      //   height: certificateElement.scrollHeight,
      //   canvasWidth: canvas.width,
      //   canvasHeight: canvas.height,
      //   aspectRatio: canvas.width / canvas.height
      // });

      // Restore hidden elements
      if (formActions) formActions.style.display = '';
      if (apiForm) apiForm.style.display = '';
      if (signatureControls) signatureControls.style.display = '';

      // Calculate dimensions to fit content properly
      const canvasAspectRatio = canvas.width / canvas.height;
      
      // Determine best page format and orientation
      let pageFormat = 'a4';
      let orientation = canvasAspectRatio > 1 ? 'landscape' : 'portrait';
      
      // If the content is very tall, consider using a larger format
      if (canvasAspectRatio < 0.7) {
        pageFormat = 'a3';
        orientation = 'portrait';
      } else if (canvasAspectRatio > 1.4) {
        pageFormat = 'a3';
        orientation = 'landscape';
      }
      
      // Create PDF with dynamic sizing
      const pdf = new jsPDF({
        orientation: orientation,
        unit: 'mm',
        format: pageFormat,
        compress: true // Enable PDF compression
      });

      // Get PDF page dimensions
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      
      // Calculate image dimensions to fit the page while maintaining aspect ratio
      let imgWidth, imgHeight;
      
      if (canvasAspectRatio > (pageWidth / pageHeight)) {
        // Image is wider relative to page - fit to width
        imgWidth = pageWidth;
        imgHeight = pageWidth / canvasAspectRatio;
      } else {
        // Image is taller relative to page - fit to height
        imgHeight = pageHeight;
        imgWidth = pageHeight * canvasAspectRatio;
      }
      
      // Center the image on the page
      const xOffset = (pageWidth - imgWidth) / 2;
      const yOffset = (pageHeight - imgHeight) / 2;

      // Debug logging for PDF dimensions
      // console.log('PDF layout:', {
      //   pageFormat: pageFormat,
      //   orientation: orientation,
      //   pageWidth: pageWidth,
      //   pageHeight: pageHeight,
      //   imgWidth: imgWidth,
      //   imgHeight: imgHeight,
      //   xOffset: xOffset,
      //   yOffset: yOffset,
      //   fitsOnPage: imgHeight <= pageHeight && imgWidth <= pageWidth
      // });

      // Add image with JPEG compression for smaller file size
      pdf.addImage(
        canvas.toDataURL('image/jpeg', 0.8), 
        'JPEG', 
        xOffset, 
        yOffset, 
        imgWidth, 
        imgHeight
      );
      
      // Generate filename
      const patientName = formData.patientName.replace(/\s+/g, '_');
      const vaccineName = formData.vaccinationType.replace(/\s+/g, '_');
      const filename = `Certificate_${patientName}_${vaccineName}_${Date.now()}.pdf`;
      
      // Convert PDF to base64 for database storage
      const pdfBlob = pdf.output('blob');
      const pdfBase64 = await blobToBase64(pdfBlob);
      
      return {
        filename,
        pdfBase64,
        pdfBlob
      };

    } catch (error) {
      //console.error('Error generating PDF:', error);
      throw error;
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  // Helper function to convert blob to base64
  const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  // Helper: dataURL to Blob
  const dataURLToBlob = (dataURL) => {
    const parts = dataURL.split(',');
    const byteString = atob(parts[1]);
    const mimeString = parts[0].match(/:(.*?);/)[1] || 'image/png';
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  };

  // Download PDF function
  const downloadPDF = async () => {
    try {
      setIsGeneratingPDF(true);
      const { filename, pdfBlob } = await generatePDF();
      
      // Create download link
      const url = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      
      //console.log('PDF downloaded:', filename);
    } catch (error) {
      alert(`Error generating PDF: ${error.message}`);
    }
  };

  // need QR functions

  return (
    <div className="App">
      {/* API Input Form */}
      <div className="api-form-container" style={{ 
        padding: '20px', 
        marginBottom: '20px', 
        backgroundColor: '#f5f5f5', 
        borderRadius: '8px',
        maxWidth: '800px',
        margin: '0 auto 20px auto'
      }}>
        
        
        {loading && (
          <div style={{ fontSize: '14px', color: '#007bff', marginTop: '10px' }}>
            Loading certificate data...
          </div>
        )}
      </div>

      {
        showCertificate === true ? (
          <div className="certificate-container">
            <div className="certificate-header">
              <div className="logo-section">
                <img src={left} alt="left-box" className="left-box" />
              </div>
                <div className="healthbouk-icon">
                  <img src={logo} alt="Healthbouk Logo" className="logo-image" />
                </div>

              <div className="qr-section">
                <div className="qr-placeholder">
                  <img src={qr} alt="Healthbouk QR" className="logo-image" />
                </div> 
              </div>
            </div>

            <h1 className="certificate-title">VACCINATION CERTIFICATE</h1>

            <div className="certificate-badge">
              <span className="vaccine-type">{formData.vaccinationType}</span>
            </div>

            <div className="certificate-recipient">
              <p className="issued-to">This certificate is issued to</p>
              <h2 className="patient-name">{formData.patientName}</h2>
              <div className="name-border"></div>
            </div>
            
            <div className="certificate-details">
              <p>
                born on <strong>{formData.birthDate}</strong>, received the <strong>{formData.vaccinationType}</strong> vaccination on <strong>{formData.vaccinationDate}</strong>, administered by <strong>{formData.serviceProvider}</strong>.
              </p>
            </div>

            
            <div className="signature-section">
              {
                showForms === true ? (
                  <>
                    <p className="signature-label">[Sign Here]</p>
                    <div className="signature-box">
                      {formData.signature ? (
                        <img src={formData.signature} alt="Signature" className="signature-image" />
                      ) : (
                        <canvas
                          ref={canvasRef}
                          className="signature-canvas"
                          width={getCanvasSize().width}
                          height={getCanvasSize().height}
                        />
                      )}
                    </div>
                    <div className="signature-controls">
                      <button type="button" onClick={clear} className="clear-btn">Clear</button>
                      <button type="button" onClick={save} className="save-btn">Save Signature</button>
                    </div>
                  </>
                ) :
                  <>
                    <div className="signature-box">
                      {formData.signature ? (
                        <img src={formData.signature} alt="Signature" className="signature-image" />
                      ) : null}
                    </div>
                  </>
              }
            </div>
              
            <div className="certificate-footer">
              <div className="footer-left">
                <p><strong>Service Provider:</strong> {formData.serviceProvider}</p>
              </div>
              <div className="footer-center">
                <p><strong>Certification ID:</strong> {generateCertificateId()}</p>
              </div>
              <div className="footer-right">
                {isSignatureSubmitted ? (
                  <p><strong>Verified Date:</strong> {dateVerified}</p>
                ) : (
                  <p style={{ visibility: 'hidden' }}><strong>Verified Date:</strong> {dateVerified}</p>
                )}
              </div>
            </div>
            <img src={right} alt="right-box" className="right-decorative-box" />
          </div>
        ) : null
      }
      {/* <div className="certificate-container">
        <div className="certificate-header">
          <div className="logo-section">
            <img src={left} alt="left-box" className="left-box" />
          </div>
            <div className="healthbouk-icon">
              <img src={logo} alt="Healthbouk Logo" className="logo-image" />
            </div>

          <div className="qr-section">
            <div className="qr-placeholder">
              <img src={qr} alt="Healthbouk QR" className="logo-image" />
            </div> 
          </div>
        </div>

        <h1 className="certificate-title">VACCINATION CERTIFICATE</h1>

        <div className="certificate-badge">
          <span className="vaccine-type">{formData.vaccinationType}</span>
        </div>

        <div className="certificate-recipient">
          <p className="issued-to">This certificate is issued to</p>
          <h2 className="patient-name">{formData.patientName}</h2>
          <div className="name-border"></div>
        </div>
        
        <div className="certificate-details">
          <p>
            born on <strong>{formData.birthDate}</strong>, received the <strong>{formData.vaccinationType}</strong> vaccination on <strong>{formData.vaccinationDate}</strong>, administered by <strong>{formData.serviceProvider}</strong>.
          </p>
        </div>

        
        <div className="signature-section">
          {
            showForms === true ? (
              <>
                <p className="signature-label">[Sign Here]</p>
                <div className="signature-box">
                  {formData.signature ? (
                    <img src={formData.signature} alt="Signature" className="signature-image" />
                  ) : (
                    <canvas
                      ref={canvasRef}
                      className="signature-canvas"
                      width={getCanvasSize().width}
                      height={getCanvasSize().height}
                    />
                  )}
                </div>
                <div className="signature-controls">
                  <button type="button" onClick={clear} className="clear-btn">Clear</button>
                  <button type="button" onClick={save} className="save-btn">Save Signature</button>
                </div>
              </>
            ) :
              <>
                <div className="signature-box">
                  {formData.signature ? (
                    <img src={formData.signature} alt="Signature" className="signature-image" />
                  ) : null}
                </div>
              </>
          }
        </div>
          
        <div className="certificate-footer">
          <div className="footer-left">
            <p><strong>Service Provider:</strong> {formData.serviceProvider}</p>
          </div>
          <div className="footer-center">
            <p><strong>Certification ID:</strong> {generateCertificateId()}</p>
          </div>
          <div className="footer-right">
            {isSignatureSubmitted ? (
              <p><strong>Verified Date:</strong> {dateVerified}</p>
            ) : (
              <p style={{ visibility: 'hidden' }}><strong>Verified Date:</strong> {dateVerified}</p>
            )}
          </div>
        </div>
        <img src={right} alt="right-box" className="right-decorative-box" />
      </div> */}
      {error && (
          <div style={{ color: 'red', fontSize: '20px', marginTop: '10px' }}>
            {error}
          </div>
      )}
      {
        showForms === true ? (
          <div className="form-actions">
            <input
              type="file"
              accept=".png"
              onChange={handleFileUpload}
              style={{ display: 'none' }}
              id="signature-upload"
            />
            <label htmlFor="signature-upload" className="upload-btn">
              Upload PNG
            </label>
            <button 
              type="button" 
              className="download-btn"
              onClick={downloadPDF}
              disabled={isGeneratingPDF || !formData.signature}
            >
              {isGeneratingPDF ? 'Generating...' : 'Download PDF'}
            </button>
            <button 
              type="submit" 
              className="submit-btn"
              onClick={handleSubmit}
              disabled={isSubmitting || isGeneratingPDF || !formData.signature}
              style={{ 
                backgroundColor: !formData.signature ? '#6c757d' : '#28a745',
                cursor: (!formData.signature || isSubmitting || isGeneratingPDF) ? 'not-allowed' : 'pointer'
              }}
            >
              {isSubmitting ? 'Submitting...' : 'Submit Signature'}
            </button>
          </div>
        ) : null
      }

      
    </div>
  );
}

export default App;
